@if (link) {
  <a
    nz-button
    nzType="text"
    class="icon-btn"
    [routerLink]="link"
    [queryParams]="queryParams"
    [attr.aria-label]="ariaLabel"
    nz-tooltip
    [nzTooltipTitle]="hint"
  >
    <i nz-icon [nzType]="icon" nzTheme="outline"></i>
  </a>
} @else if (confirmTitle) {
  <button
    type="button"
    nz-button
    nzType="text"
    class="icon-btn"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel"
    nz-tooltip
    [nzTooltipTitle]="hint"
    nz-popconfirm
    [nzPopconfirmTitle]="confirmTitle"
    (nzOnConfirm)="confirmed.emit()"
  >
    <i nz-icon [nzType]="icon" nzTheme="outline"></i>
  </button>
} @else {
  <button
    type="button"
    nz-button
    nzType="text"
    class="icon-btn"
    [class.icon-btn--loading]="loading"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel"
    nz-tooltip
    [nzTooltipTitle]="hint"
    (click)="pressed.emit()"
  >
    <i nz-icon [nzType]="icon" nzTheme="outline"></i>
  </button>
}
